var _regeneratorRuntime = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\regenerator\\index.js");

var _asyncToGenerator = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\asyncToGenerator.js");

var EventEmitter = require('events');

var EthereumProvider = require('ethereum-provider');

var ConnectionManager = require('../ConnectionManager');

var monitor = function monitor(provider) {
  function update(status) {
    provider.status = status;
    if (provider instanceof EventEmitter) provider.emit('status', status);
  }

  function checkSyncing() {
    return _checkSyncing.apply(this, arguments);
  }

  function _checkSyncing() {
    _checkSyncing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return provider.send('eth_syncing');

            case 3:
              if (!_context.sent) {
                _context.next = 5;
                break;
              }

              update('syncing');

            case 5:
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
    return _checkSyncing.apply(this, arguments);
  }

  function checkConnected() {
    return _checkConnected.apply(this, arguments);
  }

  function _checkConnected() {
    _checkConnected = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!provider.inSetup) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", setTimeout(checkConnected, 1000));

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return provider.send('eth_chainId');

            case 5:
              update('connected');
              setTimeout(checkSyncing, 500);
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              update('disconnected');

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 9]]);
    }));
    return _checkConnected.apply(this, arguments);
  }

  update('loading');
  checkConnected();
  provider.on('connect', function () {
    return checkConnected();
  });
  provider.on('close', function () {
    return update('disconnected');
  });
  return provider;
};

module.exports = function (connections, targets, options) {
  // If window.ethereum and injected is a target in any priority, return ethereum provider
  if (connections.injected.__isProvider && targets.map(function (t) {
    return t.type;
  }).indexOf('injected') > -1) {
    delete connections.injected.__isProvider;
    return monitor(connections.injected);
  }

  var provider = new EthereumProvider(new ConnectionManager(connections, targets, options));
  provider.setMaxListeners(128);
  return monitor(provider);
};